
































































































































import { POSPayment, POSTicketDetail } from '@pos/interfaces/pos-v2';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import BpcPosPaymentBalanceDetails from './pos-payment-balance-details.vue';
import BpcPosTerminalSelector from '@pos/components/v2/pos-terminal-selector.vue';
import { ConfirmationModalConfig } from '@shared/interfaces/confirmation-modal-config';
import BpcConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';

@Component({
  name: 'bpc-pos-nepting-payment-modal',
  components: {
    BpcConfirmationModal,
    BpcPosPaymentBalanceDetails,
    BpcPosTerminalSelector,
  },
})
export default class PosNeptingPaymentModal extends Vue {
  $refs: {
    abortPaymentConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    forcePaymentConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
  };
  // PROPS
  @Prop({ type: String, required: true })
  readonly paymentMethod: string;
  @Prop({ type: Boolean, default: false }) readonly loading: boolean;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Boolean, default: false }) readonly closeDisabled: boolean;
  @Prop({
    type: Number,
    required: true,
  })
  readonly amountToBePaid!: number;
  @Prop({
    type: Number,
    required: true,
  })
  readonly paymentAmount!: number;
  @Prop({
    type: Number,
    required: true,
  })
  readonly posSessionId!: number;
  @Prop({ type: Object, required: true }) readonly ticketDetail: POSTicketDetail;

  @Prop({ type: String, required: true }) modalTitle: string;

  @Prop({
    type: Number,
    required: true,
  })
  readonly contactId!: number;

  // DATA
  selectedPaymentTerminalId: number = null;
  showUpdatePaymentStatusButton = false;
  showActionButtons = false;
  paymentStatusVariant = '';
  paymentStatusMessage = '';
  extraPaymentStatusMessage = '';
  showPaymentStatusInfo = false;
  confirmDisabled = true;
  hideConfirmButton = false;
  savingPayment = false;
  refreshingStatus = false;
  manualRefreshingStatus = false;
  disableCloseButton = false;
  disableForceAcceptButton: boolean = true;
  abortingPayment: boolean = false;
  forcingPayment: boolean = false;
  // Resume payment data
  resumingPayment: boolean = false;
  paymentToResume: POSPayment = null;
  amountToBePaidToResume: number;
  ongoingPaymentFromOtherTicket: boolean = false;
  otherTicket: POSTicketDetail = null;

  // Computed

  get resumingPaymentModalTitle(): string {
    return this.$t('terminals.nepting.modal.resume-payment.title') as string;
  }

  get resumingPaymentModalBody(): string {
    return this.$t('terminals.nepting.modal.resume-payment.body') as string;
  }

  get terminalType(): string {
    return 'nepting';
  }

  get hasToDisableCloseButton(): boolean {
    return this.closeDisabled || this.loading || this.disableCloseButton;
  }

  get lastPayment(): POSPayment {
    return this.resumingPayment
      ? this.paymentToResume
      : this.ticketDetail.payments[this.ticketDetail.payments.length - 1];
  }

  get abortPaymentConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: 'abort-payment-confirmation-modal',
      title: this.$t('payment_terminals.modal.abort-payment-confirmation-modal.title') as string,
      body: this.$t('payment_terminals.modal.abort-payment-confirmation-modal.body') as string,
      cancelText: this.$t('global.buttons.close') as string,
      acceptText: this.$t('payment_terminals.modal.cancel_payment') as string,
      acceptButtonVariant: 'danger',
    };
  }

  get forcePaymentConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: 'force-payment-confirmation-modal',
      title: this.$t('payment_terminals.modal.force-payment-confirmation-modal.title') as string,
      body: this.$t('payment_terminals.modal.force-payment-confirmation-modal.body') as string,
      cancelText: this.$t('global.buttons.close') as string,
      acceptText: this.$t('payment_terminals.modal.force_accept_payment') as string,
      acceptButtonVariant: 'success',
    };
  }

  closeModal() {
    this.$emit('close');
  }

  async sendToTerminal() {
    this.savingPayment = true;
    this.hideConfirmButton = true;
    this.showPaymentStatusInfo = false;
    let ongoingPayment = false;
    this.resumingPayment = false;
    this.ongoingPaymentFromOtherTicket = false;
    this.otherTicket = null;
    setTimeout(() => (this.disableForceAcceptButton = false), 10000);

    ongoingPayment = await this.$posService.getOngoingPaymentForNeptingTherminal(
      this.posSessionId,
      this.selectedPaymentTerminalId,
    );

    if (!ongoingPayment['payment']) {
      const ticket = await this.$posService.createPayment(
        this.posSessionId,
        this.ticketDetail.id,
        this.paymentAmount,
        this.paymentMethod,
        this.contactId,
        this.selectedPaymentTerminalId,
      );

      this.$emit('ticket-detail-updated', ticket);
      this.showUpdatePaymentStatusButton = true;
      this.showActionButtons = true;
      this.refreshingStatus = true;
      this.listenToPaymentEvents();
    } else {
      this.resumeNeptingTerminal(ongoingPayment['ticket'], ongoingPayment['payment']);
    }
  }

  async resumeNeptingTerminal(ticket, payment) {
    if (ticket.id == this.ticketDetail.id) {
      this.hideConfirmButton = true;
      const refreshedTicket = await this.$posService.resumeNeptingPayment(
        this.posSessionId,
        ticket.id,
        payment.id,
      );
      // Same ticket we can resume
      this.resumingPayment = true;
      this.paymentToResume = payment;
      this.amountToBePaidToResume = this.amountToBePaid + this.paymentToResume.paid_amount;

      this.$emit('ticket-detail-updated', refreshedTicket);
      this.showUpdatePaymentStatusButton = true;
      this.showActionButtons = true;
      this.refreshingStatus = true;
      this.listenToPaymentEvents();
    } else {
      // Different ticket we can not resume, at least reusing componentes.
      this.ongoingPaymentFromOtherTicket = true;
      this.otherTicket = ticket;
    }
  }

  listenToPaymentEvents() {
    const paymentEventsListener = this.$posService.listenPaymentEvents(
      this.posSessionId,
      this.ticketDetail.id,
      this.paymentMethod,
    );

    if (paymentEventsListener) {
      paymentEventsListener
        .listen('.BPC\\PaymentTerminals\\Events\\TerminalPaymentRefreshed', async data => {
          console.log('TerminalPaymentRefreshed listen event', data);
        })
        .listen('.BPC\\PaymentTerminals\\Events\\TerminalPaymentCancelled', async data => {
          console.log('TerminalPaymentCancelled listen event', data);
          const extraMessage = data.cancelReason
            ? `[ ${data.cancelReason.code} ] -> ${this.$t(data.cancelReason.message)}`
            : '';
          const paymentInArray = this.ticketDetail.payments.find(
            payment => payment.id === data.paymentId,
          );
          if (paymentInArray) {
            this.$emit('payment-cancelled');
            this.savingPayment = false;
            this.abortingPayment = false;
            this.forcingPayment = false;
            this.refreshingStatus = false;
            this.showUpdatePaymentStatusButton = false;
            this.showActionButtons = false;
            this.hideConfirmButton = true;
            this.disableCloseButton = false;
            this.showpaymentStatusMessage(
              'warning',
              'payment_terminals.modal.payment_status_cancelled',
              extraMessage,
            );
            console.log('payment cancelled');
            this.$bpcEcho.leaveTerminalPaymentChannel();
          }
        })
        .listen('.BPC\\PaymentTerminals\\Events\\TerminalPaymentConfirmed', async data => {
          console.log('TerminalPaymentConfirmed listen event', data);
          const paymentInArray = this.ticketDetail.payments.find(
            payment => payment.id === data.paymentId,
          );
          if (paymentInArray) {
            this.$emit('success-payment');
            this.savingPayment = false;
            this.forcingPayment = false;
            this.hideConfirmButton = true;
            this.refreshingStatus = false;
            this.showUpdatePaymentStatusButton = false;
            this.showActionButtons = false;
            this.disableCloseButton = false;
            this.showpaymentStatusMessage(
              'success',
              'payment_terminals.modal.payment_status_approved',
            );
            console.log('payment confirmed');
            this.$bpcEcho.leaveTerminalPaymentChannel();
          }
        })
        .listen('.BPC\\PaymentTerminals\\Events\\TerminalPaymentPollingComplete', async data => {
          const paymentInArray = this.ticketDetail.payments.find(
            payment => payment.id === data.paymentId,
          );
          if (paymentInArray) {
            this.$emit('polling-complete');
            this.savingPayment = false;
            this.hideConfirmButton = true;
            this.refreshingStatus = false;
            this.showUpdatePaymentStatusButton = true;
            this.showActionButtons = true;
            this.disableCloseButton = false;
            this.showpaymentStatusMessage(
              'info',
              'payment_terminals.modal.payment_polling_complete',
            );
          }
        });
    }
  }

  async updateTerminalPaymentStatus() {
    const lastPaymentId = this.lastPayment?.id;
    this.manualRefreshingStatus = true;

    const ticketDetail = await this.$posService.updateTerminalPaymentStatus(
      this.posSessionId,
      this.ticketDetail.id,
      lastPaymentId,
    );
    this.manualRefreshingStatus = false;
    this.$emit('ticket-detail-updated', ticketDetail);
  }

  showAbortPaymentConfirmationModal() {
    this.$refs.abortPaymentConfirmationModal.onOpenModal(1);
  }

  async abortNeptingTerminal() {
    this.abortingPayment = true;
    this.$refs.abortPaymentConfirmationModal.onCloseModal();
    const lastPaymentId = this.lastPayment?.id;

    await this.$posService.abortNeptingTerminal(
      this.posSessionId,
      this.ticketDetail.id,
      lastPaymentId,
    );

    this.$emit('payment-cancelled');
  }

  showForcePaymentConfirmationModal() {
    this.$refs.forcePaymentConfirmationModal.onOpenModal(1);
  }

  async forceAcceptNeptingPayment() {
    this.forcingPayment = true;
    this.$refs.forcePaymentConfirmationModal.onCloseModal();
    const lastPaymentId = this.lastPayment?.id;

    await this.$posService.forceAcceptNeptingPayment(
      this.posSessionId,
      this.ticketDetail.id,
      lastPaymentId,
    );

    // this.$emit('payment-cancelled');
  }

  showpaymentStatusMessage(variant, message, extraMessage = '') {
    this.paymentStatusVariant = variant;
    this.paymentStatusMessage = message;
    this.extraPaymentStatusMessage = extraMessage;
    this.showPaymentStatusInfo = true;
  }

  preventEnterSubmit(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  @Watch('selectedPaymentTerminalId')
  onSelectedPaymentTerminalIdChanged(newTerminalId: number) {
    if (newTerminalId) {
      this.confirmDisabled = false;
      this.sendToTerminal();
    } else {
      this.confirmDisabled = true;
    }
  }

  @Watch('showModal')
  onShowModalChanged(newShowModal: boolean) {
    if (newShowModal) {
      console.log('new show modal');
      this.$bpcEcho.leaveTerminalPaymentChannel();
      this.selectedPaymentTerminalId = null;
      this.confirmDisabled = true;
      this.showUpdatePaymentStatusButton = false;
      this.showActionButtons = false;
      this.paymentStatusVariant = '';
      this.paymentStatusMessage = '';
      this.showPaymentStatusInfo = false;
      this.hideConfirmButton = false;
      this.savingPayment = false;
      this.refreshingStatus = false;
      this.resumingPayment = false;
      this.forcingPayment = false;
      this.disableForceAcceptButton = true;
      this.ongoingPaymentFromOtherTicket = false;
      this.otherTicket = null;
    }
  }
}
